import { render, staticRenderFns } from "./HomeScroller.vue?vue&type=template&id=dd185d62&"
import script from "./HomeScroller.vue?vue&type=script&lang=js&"
export * from "./HomeScroller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports